var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"mr-3",class:_vm.clicable ? 'arp-cursor-pointer' : '',attrs:{"src":_vm.imgSRC,"width":"200px"},on:{"click":function($event){return _vm.emitClick()}}})}
var staticRenderFns = []

export { render, staticRenderFns }